<template>
  <div>
    <v-card
      flat
      outlined
      rounded="lg"
      v-for="(item, index) in employees"
      :key="index"
      class="mb-5"
    >
      <v-row class="mx-5">
        <v-col cols="12" class="d-flex-column">
          <div class="d-flex justify-center text-h6 text-xs-subtitle-2">Employee #{{ index + 1 }}</div>
        </v-col>
        <!-- M/F  -->
        <v-col cols="12" sm="4">
          <div>M/F</div>
          <v-radio-group
            v-model="item.maleOrFemale"
            class="mt-0"
          >
            <v-radio
              label="Male"
              value="male"
            ></v-radio>
            <v-radio
              label="Female"
              value="female"
            ></v-radio>
          </v-radio-group>
        </v-col>
        <!-- Employed? -->
        <v-col cols="12" sm="4">
          <div>Employed</div>
          <v-radio-group
            v-model="item.isEmployed"
            class="mt-0"
          >
            <v-radio
              label="Yes"
              :value="true"
            ></v-radio>
            <v-radio
              label="No"
              :value="false"
            ></v-radio>
          </v-radio-group>
        </v-col>
        <!-- Condition -->
        <v-col cols="12" sm="4">
          <div>Condition</div>
          <v-select
            outlined
            class="rounded-lg"
            hide-details
            :items="conditions"
            v-model="item.condition"
          ></v-select>
        </v-col>
        <!-- Date of onset -->
        <v-col cols="12" sm="3">
          <v-menu
            ref="dateOfOnsetMenu"
            v-model="item.dateOfOnsetMenu"
            :close-on-content-click="false"
            :return-value.sync="item.dateOfOnset"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <div>Date of Onset</div>
              <v-text-field
                v-model="item.dateOfOnset"
                outlined
                class="rounded-lg"
                hide-details
                append-icon="mdi-calendar"
                v-bind="attrs"
                v-on="on"
                readonly
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="item.dateOfOnset"
              scrollable
            >
              <v-spacer></v-spacer>
              <v-btn
                text
                color="primary"
                @click="item.dateOfOnsetMenu = false"
              >
                Cancel
              </v-btn>
              <v-btn
                text
                color="primary"
                @click="$refs.dateOfOnsetMenu[index].save(item.dateOfOnset)"
              >
                OK
              </v-btn>
            </v-date-picker>
          </v-menu>
        </v-col>
        <!-- Last date treated -->
        <v-col cols="12" sm="3">
          <v-menu
            ref="lastDateTreatedMenu"
            v-model="item.lastDateTreatedMenu"
            :close-on-content-click="false"
            :return-value.sync="item.lastDateOfTreatment"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <div>Last Date Treated</div>
              <v-text-field
                v-model="item.lastDateOfTreatment"
                outlined
                class="rounded-lg"
                hide-details
                append-icon="mdi-calendar"
                v-bind="attrs"
                v-on="on"
                readonly
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="item.lastDateOfTreatment"
              scrollable
            >
              <v-spacer></v-spacer>
              <v-btn
                text
                color="primary"
                @click="item.lastDateTreatedMenu = false"
              >
                Cancel
              </v-btn>
              <v-btn
                text
                color="primary"
                @click="$refs.lastDateTreatedMenu[index].save(item.lastDateOfTreatment)"
              >
                OK
              </v-btn>
            </v-date-picker>
          </v-menu>
        </v-col>
        <!-- Treatment/Drug -->
        <v-col cols="12" sm="3">
          <div>Treatment/Drug</div>
          <v-text-field
            v-model="item.treatmentOrDrug"
            outlined
            append-icon="mdi-prescription"
            class="rounded-lg"
            hide-details
          ></v-text-field>
        </v-col>
        <!-- Degree of Recovery -->
        <v-col cols="12" sm="3">
          <div>Degree of Recovery</div>
          <v-text-field
            v-model="item.percentOfRecovery"
            outlined
            append-icon="mdi-percent"
            class="rounded-lg"
            hide-details
            type="number"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          icon
          large
          @click="removeEmployee(index)"
        >
          <v-icon left>mdi-delete</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-btn
      color="secondary"
      outlined
      class="mt-5"
      @click="addNewEmployee"
    >
      Add Employee
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'FormCondEmployee',
  props: [
    'tEmployees',
    'conditions',
  ],
  data() {
    return {
      employees: [...this.tEmployees],
      employeeType: 'condition',
    };
  },
  watch: {
    employees(oldArray, newArray) {
      const ae = [];
      this.$store.state.benefitsPacket.employees.forEach((item) => {
        if (item.type !== this.employeeType) {
          ae.push(item);
        }
      });

      newArray.forEach((item) => {
        ae.push(item);
      });
      this.$store.commit('updateBenefitsEmployees', ae);
    },
  },
  computed: {
    employeeLength() {
      return this.$store.state.benefitsPacket.employees.length;
    },
  },
  methods: {
    removeEmployee(value) {
      this.employees.splice(value, 1);
    },
    addNewEmployee() {
      const emp = {
        type: this.employeeType,
        maleOrFemale: null,
        employed: false,
        condition: null,
        dateOfOnset: null,
        lastDateTreated: null,
        treatment: null,
        degreeOfRecovery: null,
      };

      if (this.employeeLength > 4) {
        this.$emit('showDialog');
      } else {
        this.employees.push(emp);
      }
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
